import { combineReducers } from 'redux';

import { reducer as appStorageReducer } from './ducks/appStorage';
import { reducer as appUploadReducer } from './ducks/appUpload';
import { reducer as buildsReducer } from './ducks/builds';

const reducers = {
  appStorage: appStorageReducer,
  appUpload: appUploadReducer,
  builds: buildsReducer,
};

export default combineReducers(reducers);
